// One reading of the amount, shared by validation, display and the request
// body, so the three cannot disagree.
//
// They did. `parseInt(amount) >= 100` gated the journey, `parseInt(amount)`
// was displayed on the summary, and `Number(amount)` was transmitted -- so a
// field holding "100.99" validated as 100, showed 100 and charged 100.99.
// Three numbers from one entry. Nothing here rounds or truncates: a payer's
// number is transmitted verbatim or refused visibly at the field.

// The floor every deposit amount has always been held to. It was a literal at
// three call sites and a fourth in a translated hint.
export const MIN_PAYABLE_AMOUNT = 100;

// Keystroke filter for a human-entered amount. Whole units only, matching the
// manual deposit field this repository has always had: a decimal point cannot
// be typed, so nothing downstream ever has to decide what to do with one.
export const digitsOnly = (value: string): string => value.replace(/[^0-9]/g, "");

// The number the pay body will carry. NaN for anything that is not a number,
// which every caller treats as invalid rather than as zero.
export const payableAmount = (amount: string): number => Number(amount.trim());

export const isPayableAmount = (amount: string): boolean => {
  if (amount.trim() === "") return false;

  const value = payableAmount(amount);

  return Number.isFinite(value) && value >= MIN_PAYABLE_AMOUNT;
};
